  <template>
  <UIModal
    modal-class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 overflow-y-auto"
    modal-content-class="inline-block align-center bg-white rounded-lg px-4 pt-5 pb-4 text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6 activity-log-modal"
    :show-modal="true"
    @hide="$emit('close')"
      :close-on-backdrop="false"
      hide-footer
      hide-close-button
      hide-title
      :size="'sm'"
      body-class="!p-0"
  >
    <div>
      <div>
        <div class="text-center overflow-auto">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-title"
          >
            {{ computedTitle }}
          </h3>
          <div class="mt-2">
            <UIJsonPrettyView :data="data" :depth="1" />
          </div>
          <div class="mt-2" v-if="isDebug && metaData">
            <p>{{ $t('audit.changeModal.additionalMetaData') }}</p>
            <UIJsonPrettyView :data="metaData" :depth="1" />
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-6">
        <button
          type="button"
          class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-red-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
          @click="$emit('close')"
        >
          {{ $t('common.close') }}
        </button>
      </div>
    </div>
  </UIModal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import UIModal from '@/compatibility/modal/UIModal.vue'


import UIJsonPrettyView from '../UIComponents/UIJsonPrettyView.vue'



export default defineComponent({
  components: { UIJsonPrettyView, UIModal },
  name: 'ChangeModal',
  emits: ['close'],
  computed: {
    computedTitle() {
      return this.title || this.$t('audit.changeModal.title')
    }
  },
  props: {
    data: Object,
    metaData: Object,
    title: {
      type: String,
      default: undefined,
    },
    isDebug: {
      type: Boolean,
      default: false,
    },
  },
})
</script>

<style lang="scss" >
   .activity-log-modal {
    min-width: 550px !important;
   }
</style>
